'use client';

import { useEffect, useState } from 'react';

interface AdUnitProps {
  slot?: string;
  style?: React.CSSProperties;
  format?: string;
  responsive?: string;
  className?: string;
}

export default function AdUnit({
  slot,
  style = { display: 'block' },
  format = 'auto',
  responsive = 'true',
  className = '',
}: AdUnitProps) {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (!isClient || !slot) return;
    try {
      ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({});
    } catch (e) {
      console.warn('AdSense load error:', e);
    }
  }, [isClient, slot]);

  if (!isClient) return null;

  return (
    <div className={`w-full my-6 flex justify-center items-center overflow-hidden ${className}`}>
      <ins
        className="adsbygoogle w-full"
        style={style}
        data-ad-client="ca-pub-8520506164876944"
        data-ad-slot={slot || ""}
        data-ad-format={format}
        data-full-width-responsive={responsive}
      />
    </div>
  );
}
